var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1146)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.104,
    r: 20,
    fill: "url(#paint0_linear_101_1146)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.104,
    r: 20,
    fill: "url(#paint1_linear_101_1146)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.104,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1146)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.104,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1146)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8629 11.105C21.9268 11.0988 21.0663 11.6274 20.6493 12.4636L20.2625 13.2371C20.1101 13.2937 19.9601 13.3557 19.8118 13.4225L18.9919 13.1492C18.1061 12.8536 17.123 13.088 16.4666 13.755C15.8197 14.4125 15.5976 15.3804 15.8896 16.2531L16.1629 17.0714C16.0947 17.2208 16.0308 17.3717 15.9727 17.5253L15.2024 17.9105C14.3671 18.3271 13.837 19.1868 13.8438 20.1225C13.8506 21.0452 14.3776 21.8868 15.2008 22.2978L15.9759 22.6878C16.0328 22.8403 16.0945 22.9903 16.1613 23.1385L15.8896 23.9568C15.5942 24.8418 15.8279 25.824 16.4938 26.4805C17.1507 27.1283 18.1188 27.3505 18.9919 27.0591L19.8102 26.7874C19.9594 26.8554 20.1107 26.9178 20.2641 26.976L20.6493 27.7448C21.0663 28.5809 21.9268 29.1106 22.8629 29.1033C23.7854 29.0971 24.6273 28.5687 25.0382 27.7448L25.4234 26.9744C25.5777 26.9172 25.7303 26.8551 25.8805 26.7874L26.6956 27.0591C27.5687 27.3504 28.5368 27.1284 29.1937 26.4805C29.86 25.8236 30.0941 24.8405 29.7979 23.9552L29.5262 23.1369C29.5941 22.9881 29.6569 22.8375 29.7148 22.6846L30.4851 22.2978C31.3089 21.887 31.8369 21.0456 31.8437 20.1225C31.8505 19.1867 31.3204 18.3271 30.4851 17.9105L29.7116 17.5237C29.6547 17.3703 29.5931 17.2191 29.5262 17.0698L29.7979 16.2531V16.2515C30.0891 15.3792 29.8674 14.4121 29.2209 13.755C28.5645 13.0879 27.5814 12.8537 26.6956 13.1492L25.8757 13.4225C25.7269 13.3548 25.5763 13.2918 25.4234 13.2339L25.0382 12.4636C24.6273 11.6397 23.7854 11.1122 22.8629 11.105ZM22.8501 12.7417C23.1579 12.7441 23.436 12.9186 23.5742 13.1956L24.0936 14.2345C24.1424 14.3322 24.2102 14.4192 24.2931 14.4902C24.376 14.5613 24.4723 14.6151 24.5763 14.6484C24.8846 14.7468 25.184 14.8702 25.4713 15.0192C25.5683 15.0697 25.6744 15.1002 25.7834 15.109C25.8924 15.1178 26.002 15.1047 26.1058 15.0704L27.2119 14.7028H27.2135C27.5115 14.6032 27.8353 14.6811 28.0542 14.9026C28.2698 15.1218 28.3426 15.4417 28.2444 15.7353V15.7369L27.8783 16.8381C27.8442 16.941 27.8309 17.0496 27.8391 17.1578C27.8474 17.2659 27.877 17.3712 27.9263 17.4678C28.0735 17.7557 28.1957 18.0558 28.2923 18.3644C28.3252 18.4695 28.379 18.5668 28.4504 18.6505C28.5218 18.7343 28.6094 18.8028 28.7079 18.8519L29.7531 19.3746C30.0343 19.5147 30.2093 19.7981 30.207 20.1098C30.2048 20.4169 30.0303 20.6956 29.7531 20.8338H29.7515L28.7126 21.3548C28.6152 21.4038 28.5286 21.4717 28.4578 21.5546C28.3869 21.6374 28.3334 21.7336 28.3003 21.8375C28.2013 22.1459 28.0774 22.4453 27.9279 22.7325C27.8772 22.8297 27.8465 22.9361 27.8378 23.0454C27.829 23.1547 27.8422 23.2646 27.8767 23.3687L28.2444 24.4731C28.344 24.7709 28.2684 25.0947 28.0462 25.3138C27.8272 25.5297 27.5072 25.6036 27.2135 25.5056H27.2119L26.1106 25.1396C26.0075 25.1052 25.8986 25.0918 25.7902 25.1C25.6818 25.1082 25.5761 25.138 25.4793 25.1875C25.191 25.3353 24.8918 25.4581 24.5827 25.5551C24.4777 25.588 24.3804 25.6418 24.2966 25.7132C24.2128 25.7846 24.1443 25.8722 24.0952 25.9707L23.5742 27.0127C23.436 27.2899 23.158 27.4642 22.8501 27.4667C22.5376 27.4691 22.2536 27.2941 22.1133 27.0127L21.5939 25.9755C21.5451 25.8777 21.4773 25.7908 21.3944 25.7197C21.3115 25.6486 21.2152 25.5948 21.1112 25.5615C20.8024 25.4625 20.5023 25.3388 20.2146 25.1891C20.1174 25.1384 20.011 25.1078 19.9017 25.099C19.7924 25.0902 19.6825 25.1034 19.5785 25.138L18.474 25.5056C18.1803 25.6036 17.8603 25.5303 17.6413 25.3138C17.4191 25.0948 17.3435 24.7709 17.4432 24.4731V24.4715L17.8092 23.3703C17.8432 23.267 17.8564 23.158 17.8479 23.0496C17.8394 22.9412 17.8094 22.8356 17.7596 22.7389C17.612 22.4516 17.4891 22.1521 17.392 21.8439C17.3593 21.7395 17.3059 21.6426 17.2351 21.5592C17.1642 21.4757 17.0774 21.4073 16.9796 21.358L15.936 20.8338H15.9344C15.6572 20.6955 15.4827 20.417 15.4805 20.1098C15.4782 19.7981 15.6533 19.5148 15.9344 19.3746L16.9733 18.8551C17.071 18.8063 17.1579 18.7385 17.229 18.6556C17.3001 18.5727 17.3539 18.4764 17.3872 18.3724C17.4862 18.0641 17.6101 17.7647 17.7596 17.4774C17.8101 17.3804 17.8406 17.2743 17.8494 17.1653C17.8582 17.0563 17.845 16.9467 17.8108 16.8429L17.4432 15.7369V15.7353C17.3449 15.4417 17.4177 15.1217 17.6333 14.9026C17.8522 14.6802 18.176 14.6035 18.474 14.7028L19.5769 15.0704C19.68 15.1047 19.7889 15.1182 19.8973 15.1099C20.0057 15.1017 20.1114 15.0719 20.2082 15.0224C20.4957 14.8752 20.7951 14.753 21.1032 14.6564C21.2082 14.6235 21.3055 14.5697 21.3893 14.4983C21.4731 14.4269 21.5416 14.3394 21.5907 14.2409L22.1133 13.1956C22.2536 12.9141 22.5376 12.7392 22.8501 12.7417ZM22.8469 16.0134C20.5969 16.0134 18.7506 17.8533 18.7505 20.1034C18.7505 22.3534 20.5969 24.1982 22.8469 24.1982C25.097 24.1982 26.9354 22.3534 26.9354 20.1034C26.9353 17.8533 25.097 16.0134 22.8469 16.0134ZM22.8469 17.65C24.2125 17.65 25.2987 18.7378 25.2987 20.1034C25.2987 21.4689 24.2125 22.5615 22.8469 22.5615C21.4814 22.5615 20.3872 21.4689 20.3872 20.1034C20.3872 18.7378 21.4814 17.65 22.8469 17.65Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1146",
    x: 0.847312,
    y: 0.104004,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1146"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1146",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1146",
    x1: 38.7548,
    y1: 34.3238,
    x2: 26.6622,
    y2: -0.567822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1146",
    x1: 5.10198,
    y1: 37.8458,
    x2: 40.5855,
    y2: 2.36223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1146",
    x1: 24.4598,
    y1: 40.104,
    x2: 42.8267,
    y2: 20.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1146",
    x1: 0.84375,
    y1: 2.96115,
    x2: 29.7595,
    y2: 47.1234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminSettings);
export default __webpack_public_path__ + "static/media/admin_settings.6042f030f9b11e59a8be0da1bae530f8.svg";
export { ForwardRef as ReactComponent };